export default {
  "account": {
    "curatedCollections": "Kuruojamos kolekcijos",
    "curatedCollectionsInfo": "Žemiau rasite visas jūsų kuruotas kolekcijas",
    "editProfile": "Redaguoti profilį",
    "likes": "Patinka",
    "linkAccount": "Mano paskyra",
    "linkLogin": "Prisijungti",
    "linkLoginJoin": "Prisijungti/Prisijungti",
    "linkLogout": "Atsijungti",
    "myProfile": "Mano profilis",
    "notifications": {
      "loggedIn": "Dabar esate prisijungę. Sveiki!",
      "loggedOut": "Dabar esate prisijungę.",
      "noCollections": {
        "curated": "Dar ne kuravote jokių rinkinių",
        "private": "Kol kas nesukūrėte jokių privačių galerijų",
        "public": "Kol kas nesukūrėte jokių viešų galerijų"
      },
      "noLikedItems": "Kol kas neturite patikusių prekių"
    },
    "privateCollections": "Privačios galerijos",
    "profile": "Man patinkančios prekės, kolekcijos ir galerijos",
    "profileSettings": "Profilio nustatymai",
    "publicCollections": "Viešos galerijos",
    "settings": "Nustatymai",
    "title": "Mano paskyra"
  },
  "actions": {
    "accept": "Priimti",
    "cancel": "Atšaukti",
    "close": "uždaryti",
    "continue": "tęsti",
    "download": "Parsisiųsti",
    "edit": "Redaguoti",
    "feedback": "Atsiliepimas",
    "goBack": "Grįžti",
    "goHome": "Eikite į pagrindinį puslapį",
    "learnMore": "Sužinokite daugiau",
    "like": "Patinka",
    "move": "Perkelti",
    "next": "Kitas",
    "pin": "Kaištis",
    "preview": "Peržiūra",
    "previous": "Ankstesnis",
    "providedBy": "Tiekėjas {provider}",
    "reject": "Atmesti",
    "save": "Išsaugoti",
    "send": "Siųsti",
    "share": "Dalintis",
    "shareOn": "Dalintis {social}",
    "skip": "Praleisti",
    "viewAt": "Peržiūrėkite {link}",
    "viewDocument": "Peržiūrėti dokumentą"
  },
  "attribution": {
    "country": "Šalis:",
    "creator": "Autorius:",
    "date": "Data:",
    "institution": "Įstaiga:",
    "title": "Pavadinimas:"
  },
  "automatedCardGroup": {
    "item": "Naujausi prekių",
    "organisation": "Organizacijos",
    "place": "Vietos",
    "time": "Rekomenduojami šimtmečiai",
    "topic": "Rekomenduojamos temos"
  },
  "blog": {
    "author": "Autorius",
    "authors": "Autoriai",
    "blog": "Tinklaraštis",
    "by": "iki",
    "categories": "Kategorijos",
    "category": "Kategorija",
    "posts": "Tinklaraščio įrašai",
    "published": "Paskelbta {date}",
    "relatedPosts": "Susiję įrašai"
  },
  "cardLabels": {
    "organisation": "Organizacija",
    "person": "Asmuo",
    "place": "Vieta",
    "theme": "Tema",
    "time": "Amžius",
    "topic": "Tema"
  },
  "clearAllFilters": "išvalyti visus filtrus",
  "collections": {
    "actions": {
      "edit": "Redaguoti kolekciją",
      "update": "Atnaujinti kolekciją"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "dizaineriai",
          "name": "Projektuotojas | Projektuotojai",
          "select": "Pasirinkite dizainerius"
        },
        "proxy_dc_format": {
          "moreName": "technikos",
          "name": "Technika | Technikos",
          "select": "Pasirinkite technikos"
        },
        "proxy_dc_type": {
          "moreName": "elementų tipai",
          "name": "Elemento tipas | Elementų tipai",
          "select": "Pasirinkite elementų tipus"
        },
        "proxy_dcterms_medium": {
          "moreName": "medžiagos",
          "name": "Medžiaga | Medžiagos",
          "select": "Pasirinkite medžiagas"
        }
      }
    },
    "form": {
      "description": "apibūdinimas"
    },
    "notifications": {
      "update": "Kolekcija buvo atnaujinta"
    }
  },
  "collectionsYouMightLike": "Kolekcijos, kurios jums gali patikti",
  "colourSwatch": "Spalvų pavyzdys",
  "contentYouMightLike": "Turinys, kuris jums gali patikti",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Daugiau informacijos",
      "about": "Apie „Europeana“ kolekcijas",
      "forDevelopers": "Programuotojams",
      "help": "Pagalba",
      "meetUs": "Susipažinkite su komanda",
      "provide": "Tapkite duomenų teikėju",
      "subscribe": "Užsiprenumeruokite mūsų Naujienlaiškį",
      "terms": "Naudojimo sąlygos ir privatumo politika"
    },
    "headerNavigation": {
      "Collections": "Kolekcijos",
      "explore": "Tyrinėkite",
      "teachers": "Mokytojams"
    }
  },
  "curatedAutomatically": "Automatiškai kuruoja „Europeana“.",
  "dateFilter": {
    "endDate": "Pabaigos data",
    "specificDate": "Konkreti data",
    "startDate": "Pradžios data",
    "to": "į"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Europeana API raktas",
      "noRequests": "Šiame puslapyje nebuvo panaudotos užklausos dėl Europeana API.",
      "settingsPageLinkText": "nustatymų puslapį",
      "tip": "Patarimas: jei jau turite {apiKeyLink} , galite įvesti jį {settingsPageLink} ir jis bus įtrauktas į šias API užklausų nuorodas.",
      "title": "API užklausos"
    },
    "debug": "Derinimo",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Įveskite savo Europeana API raktą ir jis bus naudojamas API užklausų nuorodose.",
          "label": "API raktas"
        },
        "enabled": {
          "description": "Jei įjungta, derinimo meniu bus rodomas puslapio poraštėje.",
          "label": "Įgalinti derinimo meniu"
        }
      },
      "title": "Nustatymai"
    }
  },
  "delete": "Ištrinti",
  "depiction": "{title} vaizdavimas",
  "directions": {
    "left": "Kairė",
    "right": "Dešinė"
  },
  "edmIsShownAtLinkAlt": "Peržiūrėti teikėjo svetainę",
  "entity": {
    "actions": {
      "cancel": "Atšaukti",
      "pin": "Prisegti elementą",
      "unpin": "Atsegti elementą",
      "viewPinned": "Peržiūrėkite prisegtus elementus"
    },
    "labels": {
      "entity": "Subjektas"
    },
    "notifications": {
      "deleted": "Jūsų galerija panaikinta.",
      "error": {
        "unpin": "Atsegant elementą įvyko klaida. Bandykite dar kartą arba praneškite apie problemą."
      },
      "pin": "Šis elementas bus rodomas kolekcijos „ {entity} “ viršuje. Informuosime jus, kai šis pakeitimas bus matomas kolekcijos puslapyje.",
      "pinLimit": {
        "body": "Kol kas pirmajame puslapyje galite prisegti tik 24 elementus. Jei norite prisegti šį elementą, būtinai atsisekite kitą elementą ir tada vėl bandykite prisegti šį.",
        "title": "Per daug prisegtų elementų"
      },
      "pinned": "Elementas prisegtas. Dabar jis yra pirmojo šios kolekcijos puslapio viršuje. Gali užtrukti iki 24 valandų, kol visi pasirodys.",
      "select": "Pasirinkite susijusį objektą, kurį norite prisegti / atsegti elementą prie jo / nuo jo.",
      "unpin": "Šis elementas nebebus rodomas kolekcijos „ {entity} “ viršuje. Informuosime jus, kai šis pakeitimas bus matomas kolekcijos puslapyje.",
      "unpinned": "Elementas buvo atsegtas. Jo nebėra šio rinkinio pirmojo puslapio viršuje. Gali prireikti iki 24 valandų, kol jis išnyks visiems."
    }
  },
  "error": "Klaida",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Tai neįmanoma, nes privačias galerijas mato tik jų kūrėjas. Jei pažįstate galerijos kūrėją, paprašykite, kad galerija būtų vieša. Arba praneškite apie šią problemą naudodami atsiliepimų mygtuką.",
      "metaTitle": "Galerija neteisėta",
      "title": "Ups! {newline} Jūs bandote peržiūrėti kito asmens privačią galeriją."
    },
    "itemNotFound": {
      "description": "Taip gali nutikti dėl šių priežasčių: šio elemento nėra arba; jis buvo panaikintas, nes neatitiko mūsų kokybės kriterijų, arba; jis buvo atnaujintas ir paskelbtas iš naujo su nauju unikaliu identifikatoriumi. Tokiu atveju pabandykite rasti elementą dar kartą.",
      "metaTitle": "Prekė nerasta",
      "title": "O ne! {newline} Mums nepavyko rasti šio elemento."
    }
  },
  "exhibitions": {
    "chapters": "Skyriai",
    "credits": "Kreditai",
    "currentChapter": "Dabartinis skyrius",
    "description": "Tyrinėti mūsų parodas",
    "exhibitions": "Parodos"
  },
  "explore": "Naršyti",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "spalvos",
      "name": "Spalva | Spalvos",
      "options": {
        "#000000": "Juoda",
        "#000080": "Tamsiai mėlyna",
        "#00008B": "Tamsiai mėlyna",
        "#0000CD": "Vidutiniškai mėlyna",
        "#0000FF": "Mėlyna",
        "#006400": "Tamsiai žalia",
        "#008000": "Žiniatinklis žalias",
        "#008080": "Teal",
        "#008B8B": "Tamsiai žalsvai mėlynas",
        "#00BFFF": "Giliai dangus mėlynas",
        "#00CED1": "Tamsus turkis",
        "#00FA9A": "Vidutinė pavasario žalia",
        "#00FF00": "Žalias",
        "#00FF7F": "Pavasario žalia",
        "#00FFFF": "Cianas",
        "#191970": "Vidurnakčio mėlyna",
        "#1E90FF": "Ryški mėlyna",
        "#20B2AA": "Šviesiai jūros žalia",
        "#228B22": "Miško žalia",
        "#2E8B57": "Jūra žalia",
        "#2F4F4F": "Tamsiai šiferis pilkas",
        "#32CD32": "Laimo žalia",
        "#3CB371": "Vidutinės jūros žalia",
        "#40E0D0": "Turkis",
        "#4169E1": "Karališkai mėlyna",
        "#4682B4": "Plieno mėlyna",
        "#483D8B": "Tamsiai šiferis mėlynas",
        "#48D1CC": "Vidutinis turkis",
        "#4B0082": "Indigo",
        "#556B2F": "Tamsiai alyvuogių žalia",
        "#5F9EA0": "Kadetas mėlynas",
        "#6495ED": "Rugiagėlių",
        "#663399": "Rebeka violetinė",
        "#66CDAA": "Vidutinis akvamarinas",
        "#696969": "Dimas Grėjus",
        "#6A5ACD": "Šiferis mėlynas",
        "#6B8E23": "Tamsiai žalia alyvuogių spalva",
        "#708090": "Šiferis pilkas",
        "#778899": "Šviesiai šiferis pilkas",
        "#7B68EE": "Vidutinio skalūno mėlyna",
        "#7CFC00": "Veja žalia",
        "#7F0000": "Žiniatinklis",
        "#7F007F": "Žiniatinklio violetinė",
        "#7FFF00": "Chartreuse",
        "#7FFFD4": "Akvamarinas",
        "#800000": "Kaštoninė",
        "#800080": "Violetinė",
        "#808000": "Alyvuogių",
        "#808080": "Internetinė pilka",
        "#87CEEB": "Dangaus mėlynumo",
        "#87CEFA": "Šviesiai dangus mėlynas",
        "#8A2BE2": "Mėlyna violetinė",
        "#8B0000": "Tamsiai raudona",
        "#8B008B": "Tamsiai purpurinė",
        "#8B4513": "Balno ruda",
        "#8FBC8F": "Tamsiai jūros žalia",
        "#90EE90": "Šviesiai žalia",
        "#9370DB": "Vidutiniškai violetinė",
        "#9400D3": "Tamsiai violetinė",
        "#98FB98": "Blyškiai žalia",
        "#9932CC": "Tamsios orchidėjos",
        "#9ACD32": "Geltona žalia",
        "#A020F0": "Violetinė",
        "#A0522D": "Rausvai ruda",
        "#A52A2A": "Ruda",
        "#A9A9A9": "Tamsiai pilka",
        "#ADD8E6": "Šviesiai mėlynas",
        "#ADFF2F": "Žalia geltona",
        "#AFEEEE": "Blyškiai turkio spalvos",
        "#B03060": "Sodri kaštoninė",
        "#B0C4DE": "Šalta mėlyna",
        "#B0E0E6": "Milteliai mėlyni",
        "#B22222": "„Firebrick“",
        "#B8860B": "Tamsi pienių",
        "#BA55D3": "Rausva orichidėjos",
        "#BC8F8F": "Rosy Brown",
        "#BDB76B": "Tamsūs chaki",
        "#BEBEBE": "Pilka",
        "#C0C0C0": "sidabras",
        "#C71585": "Rausva violetinė",
        "#CD5C5C": "Granatų",
        "#CD853F": "Peru",
        "#D2691E": "Šokoladas",
        "#D2B48C": "Tan",
        "#D3D3D3": "Šviesiai pilka",
        "#D8BFD8": "Erškėtis",
        "#DA70D6": "Orchidėja",
        "#DAA520": "Goldenrod",
        "#DB7093": "Blyškiai violetinė raudona",
        "#DC143C": "Crimson",
        "#DCDCDC": "Šviesi pilka",
        "#DDA0DD": "Slyva",
        "#DEB887": "Burwudas",
        "#E0FFFF": "Šviesiai žalsvai žydra",
        "#E6E6FA": "Levandos",
        "#E9967A": "Tamsi lašiša",
        "#EE82EE": "Violetinė",
        "#EEE8AA": "Blyški Goldenrod",
        "#F08080": "Šviesi koralų",
        "#F0E68C": "Chaki",
        "#F0F8FF": "Blyški mėlyna",
        "#F0FFF0": "Medaus rasa",
        "#F0FFFF": "Azure",
        "#F4A460": "Sandy Brown",
        "#F5DEB3": "Kvieciai",
        "#F5F5DC": "Smėlio spalvos",
        "#F5F5F5": "Baltas dūmas",
        "#F5FFFA": "Mėtų kremas",
        "#F8F8FF": "Vaiduoklis baltas",
        "#FA8072": "Lašiša",
        "#FAEBD7": "Antikvariniai balti",
        "#FAF0E6": "Linas",
        "#FAFAD2": "Šviesioji aukso spalva",
        "#FDF5E6": "Odos",
        "#FF0000": "Raudona",
        "#FF00FF": "Fuksija",
        "#FF1493": "Sodri rožinė",
        "#FF4500": "Oranžinė raudona",
        "#FF6347": "Pomidoras",
        "#FF69B4": "Ryški rožinė",
        "#FF7F50": "Koralas",
        "#FF8C00": "Tamsiai oranžinė",
        "#FFA07A": "Šviesiai rožinė",
        "#FFA500": "Oranžinė",
        "#FFB6C1": "Šviesiai rožinė",
        "#FFC0CB": "Rožinis",
        "#FFD700": "Auksas",
        "#FFDAB9": "Persiko",
        "#FFDEAD": "Navajo balta",
        "#FFE4B5": "Smėlio",
        "#FFE4C4": "Biskvito",
        "#FFE4E1": "Migla Rožė",
        "#FFEBCD": "Blanširuotas migdolas",
        "#FFEFD5": "Papajos vata",
        "#FFF0F5": "Levandų skaistalai",
        "#FFF5EE": "Žuvies kriauklė",
        "#FFF8DC": "Cornsilk",
        "#FFFACD": "Citrininis šifonas",
        "#FFFAF0": "Gėlių balta",
        "#FFFAFA": "Sniegas",
        "#FFFF00": "Geltona",
        "#FFFFE0": "Šviesiai geltona",
        "#FFFFF0": "Dramblio kaulas",
        "#FFFFFF": "Balta"
      },
      "select": "Pasirinkite spalvas"
    },
    "COUNTRY": {
      "name": "Teikianti šalis",
      "options": {
        "Albania": "Albanija",
        "Austria": "Austrija",
        "Belarus": "Baltarusija",
        "Belgium": "Belgija",
        "Bosnia and Herzegovina": "Bosnija ir Hercegovina",
        "Bulgaria": "Bulgarija",
        "Croatia": "Kroatija",
        "Cyprus": "Kipras",
        "Czech Republic": "Čekijos Respublika",
        "Denmark": "Danija",
        "Estonia": "Estija",
        "Europe": "Europa",
        "Finland": "Suomija",
        "France": "Prancūzija",
        "Georgia": "Gruzija",
        "Germany": "Vokietija",
        "Greece": "Graikija",
        "Holy See (Vatican City State)": "Šventasis Sostas (Vatikano Miesto Valstybė)",
        "Hungary": "Vengrija",
        "Iceland": "Islandija",
        "Ireland": "Airija",
        "Israel": "Izraelis",
        "Italy": "Italija",
        "Latvia": "Latvija",
        "Lithuania": "Lietuva",
        "Luxembourg": "Liuksemburgas",
        "Macedonia": "Makedonija",
        "Malta": "Malta",
        "Moldova": "Moldova",
        "Montenegro": "Juodkalnija",
        "Netherlands": "Nyderlandai",
        "Norway": "Norvegija",
        "Poland": "Lenkija",
        "Portugal": "Portugalija",
        "Romania": "Rumunija",
        "Russia": "Rusija",
        "Serbia": "Serbija",
        "Slovakia": "Slovakija",
        "Slovenia": "Slovėnija",
        "Spain": "Ispanija",
        "Sweden": "Švedija",
        "Switzerland": "Šveicarija",
        "Turkey": "Turkija",
        "Ukraine": "Ukraina",
        "United Kingdom": "Jungtinė Karalystė",
        "United States of America": "Jungtinės Amerikos Valstijos"
      },
      "select": "Pasirinkite teikiančias šalis"
    },
    "CREATOR": {
      "moreName": "kūrėjai",
      "name": "Autorius | Autoriai",
      "select": "Pasirinkite kūrėjus"
    },
    "DATA_PROVIDER": {
      "moreName": "institucijose",
      "name": "Institucija",
      "select": "Pasirinkite institucijas"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Vaizdo orientacija | Vaizdo orientacijos",
      "options": {
        "landscape": "Gulsčias",
        "portrait": "Statmenas"
      },
      "select": "Pasirinkite vaizdo orientaciją"
    },
    "IMAGE_SIZE": {
      "name": "Vaizdo dydis | Vaizdo dydžiai",
      "options": {
        "extra_large": "Ypač didelis 4MP + (pvz., 2688 x 1520 pikselių)",
        "large": "Didelis 1–4 MP (pvz., 1920 x 1080 pikselių)",
        "medium": "Vidutinis 0,5–1 MP (pvz., 850 x 850 pikselių)",
        "small": "Mažas < 0,5 MP (pvz., 650 x 600 pikselių)"
      },
      "select": "Pasirinkite vaizdo dydžius"
    },
    "LANGUAGE": {
      "name": "Kalba",
      "options": {
        "ar": "Arabų",
        "bg": "Bulgarų",
        "bs": "Bosnių",
        "ca": "Katalonų",
        "cs": "Čekų",
        "cy": "Valų",
        "da": "Danų",
        "de": "Vokiečių",
        "el": "Graikų",
        "en": "Anglų",
        "es": "Ispanų",
        "et": "Estų",
        "fi": "Suomių",
        "fr": "Prancūzų",
        "ga": "Airių",
        "gd": "Gėlų",
        "he": "Hebrajų",
        "hr": "Kroatų",
        "hu": "Vengrų",
        "is": "Islandų",
        "it": "Italų",
        "lt": "Lietuvių",
        "lv": "Latvių",
        "mk": "Makedonų",
        "mt": "Maltiečių",
        "mul": "Kelios kalbos",
        "nl": "Olandų",
        "no": "Norvegų",
        "pl": "Lenkų",
        "pt": "Portugalų",
        "ro": "Rumunų",
        "ru": "Rusų",
        "sk": "Slovakų",
        "sl": "Slovėnų",
        "sq": "Albanų",
        "sr": "Serbų",
        "sv": "Švedų",
        "tr": "Turkų",
        "uk": "Ukrainiečių"
      },
      "select": "Pasirinkite kalbas"
    },
    "MIME_TYPE": {
      "name": "Failo formatas | Failų formatai",
      "options": {
        "text/plain": "Paprastas tekstas"
      },
      "select": "Pasirinkite failų formatus"
    },
    "PROVIDER": {
      "moreName": "agregatoriai",
      "name": "Kaupykla",
      "select": "Pasirinkite agregatorius"
    },
    "REUSABILITY": {
      "name": "Ar galiu tai pakartotinai naudoti?",
      "options": {
        "open": "Taip",
        "permission": "Galbūt, kreipkitės leidimo",
        "restricted": "Taip, su sąlygomis",
        "uncategorized": "Neklasifikuota"
      },
      "select": "Pasirinkite, ar galite tai naudoti"
    },
    "TYPE": {
      "name": "Medijos tipas",
      "options": {
        "3D": "3D",
        "IMAGE": "Vaizdas",
        "SOUND": "Garsas",
        "TEXT": "Tekstas",
        "VIDEO": "Vaizdo įrašas"
      },
      "select": "Pasirinkite laikmenos tipus"
    },
    "api": {
      "name": "Ieškoti",
      "options": {
        "fulltext": "Įrašai su visu tekstu",
        "metadata": "Tik metaduomenų įrašai"
      },
      "switch": "Ieškoti tik pilno teksto elementų turinyje",
      "switchMoreInfo": "Šioje kolekcijoje galite pasirinkti, ko norite ieškoti: jei šis jungiklis įjungtas, tada ieškosite laikraščio ir dokumento tekste; jei jis išjungtas, tada ieškosite informacijos, apibūdinančios elementą, kaip ir daugumoje kitų kolekcijų."
    },
    "button": {
      "apply": "Taikyti",
      "cancel": "Atšaukti",
      "morefilters": "Daugiau filtrų",
      "reset": "Atstatyti",
      "showAll": "Rodyti visus {label}",
      "showLess": "Rodyti mažiau {label}"
    },
    "collection": {
      "name": "Tema",
      "options": {
        "archaeology": "Archeologija",
        "art": "Menas",
        "fashion": "Mada",
        "industrial": "Pramoninis paveldas",
        "manuscript": "Rankraščiai",
        "map": "Žemėlapiai ir geografija",
        "migration": "Migracija",
        "music": "Muzika",
        "nature": "Gamtos istorija",
        "newspaper": "Laikraščiai",
        "photography": "Fotografija",
        "sport": "Sportas",
        "ww1": "Pirmasis pasaulinis karas"
      },
      "select": "Pasirinkite temą"
    },
    "contentTier": {
      "name": "Prekės kokybė",
      "options": {
        "*": "Rodomi elementai, neatitinkantys mūsų paskelbimo kriterijų.",
        "0": "Tik elementai, neatitinkantys mūsų paskelbimo kriterijų",
        "1": "Žema kokybė",
        "2": "Vidutinė kokybė",
        "3": "Aukštos kokybės ir daugkartinio naudojimo sąlygos",
        "4": "Aukštos kokybės ir laisvai daugkartinio naudojimo"
      },
      "select": "Pasirinkite elemento savybes"
    },
    "moreOptions": "Leškoti, kad rastumėte {0} daugiau {1}.",
    "proxy_dc_format": {
      "name": "Formatas | Formatai",
      "select": "Pasirinkite formatus"
    },
    "proxy_dc_type": {
      "name": "Tipas | Tipai",
      "select": "Pasirinkite tipus"
    },
    "proxy_dcterms_issued": {
      "name": "Išleidimo data"
    },
    "proxy_dcterms_medium": {
      "name": "Laikmenos | Laikmena",
      "select": "Pasirinkite laikmeną"
    }
  },
  "feedback": {
    "emailOptional": "Galbūt norėsime tęsti. Įveskite savo el. Pašto adresą, jei džiaugiatės, kad susisieksime su jumis.",
    "failed": "Užklausa nepavyko. Prašome, pabandykite dar kartą.",
    "form": {
      "placeholders": {
        "email": "Įveskite savo elektroninio pašto adresą",
        "feedback": "Čia įveskite savo atsiliepimą"
      }
    },
    "policies": "Tęsdami sutinkate su mūsų {0} ir patvirtinate mūsų {1} .",
    "privacyPolicy": "Privatumo politika",
    "success": "Jūsų atsiliepimas išsiųstas.",
    "termsOfService": "Paslaugų teikimo sąlygos",
    "thankYou": "Ačiū!",
    "title": "Siųsti atsiliepimą",
    "validEmail": "Įveskite galiojantį el. Pašto adresą",
    "validFeedback": "Jūsų atsiliepimą turi sudaryti mažiausiai 5 žodžiai"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Įnešėjai",
      "dcCoverage": "Vieta-laikas",
      "dcCreator": "Autorius",
      "dcDate": "Data",
      "dcDescription": "Aprašymas",
      "dcDuration": "Trukmė",
      "dcFormat": "Formatas",
      "dcIdentifier": "Identifikatorius",
      "dcLanguage": "Kalba",
      "dcPublisher": "Leidėjas",
      "dcRelation": "Santykiai",
      "dcRights": "Teisės",
      "dcSource": "Šaltinis",
      "dcSubject": "Tema",
      "dcTitle": "Pavadinimas",
      "dcType": "Objekto tipas",
      "dctermsCreated": "Sukūrimo data",
      "dctermsExtent": "Apimtis",
      "dctermsHasPart": "Susideda iš",
      "dctermsHasVersion": "Turi versiją",
      "dctermsIsFormatOf": "Yra formatas",
      "dctermsIsPartOf": "Yra dalis",
      "dctermsIsReferencedBy": "Nurodomas",
      "dctermsIsReplacedBy": "Pakeičiamas",
      "dctermsIsRequiredBy": "Reikalingas",
      "dctermsIssued": "Išleidimo data",
      "dctermsMedium": "Medija",
      "dctermsProvenance": "Kilmė",
      "dctermsReferences": "Nurodo",
      "dctermsSpatial": "Vietos",
      "dctermsTOC": "Turinio lentelė",
      "dctermsTemporal": "Laiko",
      "edmCountry": "Teikianti šalis",
      "edmCurrentLocation": "Dabartinė vieta",
      "edmDataProvider": "Teikianti institucija",
      "edmHasMet": "Susitiko",
      "edmIncorporates": "Įtraukia",
      "edmIntermediateProvider": "Tarpinis teikėjas",
      "edmIsDerivativeOf": "Yra išvestinė iš",
      "edmIsRelatedTo": "Yra susijęs su",
      "edmIsRepresentationOf": "Ar atstovavimas",
      "edmIsSimilarTo": "Yra panašus į",
      "edmIsSuccessorOf": "Yra įpėdinis",
      "edmProvider": "Teikėjas",
      "edmRealizes": "Suvokia",
      "edmRights": "Šiame įraše esančios medijos licencija (jei nenurodyta kitaip)",
      "edmUgc": "Vartotojo sugeneruotas turinys",
      "europeanaCollectionName": "Kolekcijos pavadinimas",
      "keywords": "Raktiniai žodžiai (pateikia bendruomenė)",
      "timestampCreated": "Sukurtas laiko žyma",
      "timestampUpdate": "Laiko žyma atnaujinta",
      "wasPresentAt": "Dalyvavo",
      "year": "Metai"
    },
    "webResource": {
      "about": "RDF Apie",
      "dcDescription": "Aprašymas",
      "ebucoreHasMimeType": "„Ebucore“ MIME tipas",
      "edmRights": "Šio medijos šaltinio licencija",
      "rdfAbout": "RDF Apie"
    }
  },
  "filter": "Filtras",
  "filterResults": "Filtruoti rezultatus",
  "footer": {
    "customiseWebsiteLanguage": "Pasirinkti tinklalapio kalbą",
    "disclaimerLine1": "\"Europeana\" yra Europos Sąjungos iniciatyva, finansuojama Europos Sąjungos Europos Connecting Europe Facility ir Europos Sąjungos valstybių narių lėšomis. Europeanos paslaugas, įskaitant šią svetainę, teikia konsorciumas, kuriam vadovauja Europeana Foundation, pagal paslaugų teikimo sutartį su Europos Komisija.",
    "disclaimerLine2": "Europos Komisija negarantuoja informacijos tikslumo ir neprisiima jokios atsakomybės ar atsakomybės už šioje svetainėje pateiktą informaciją. Nei Europos Komisija, nei joks asmuo, veikiantis Europos Komisijos vardu, nėra atsakingas už šioje svetainėje esančios informacijos tikslumą ar naudojimą.",
    "findUsElsewhere": "Raskite mus kitur",
    "imageDescription": "Finansuoja Europos Sąjunga",
    "navigation": {
      "MoreInfoLabel": "Daugiau informacijos",
      "about": "Apie mus",
      "accessibility": "Prieinamumas",
      "cookies": "Slapukai",
      "forDevelopers": "Programuotojams",
      "help": "Pagalba",
      "privacy": "Privatumo politika",
      "provide": "Tapkite duomenų teikėju",
      "subscribe": "Užsiprenumeruokite mūsų Naujienlaiškį",
      "terms": "Paslaugų teikimo sąlygos"
    },
    "ourMission": "Mūsų misija",
    "ourMissionQuote": "„Europeana“ suteikia kultūros paveldo sektoriui skaitmeninimo galimybes. Rengiame žinias, įrankius ir politikas, skatinančias skaitmeninius pokyčius bei partnerystes, kurios spartina inovacijas."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Tyrinėti mūsų galerijas",
    "galleries": "Galerijos"
  },
  "goToRecord": "Eiti į įrašą",
  "header": {
    "backToMenu": "Uždaryti paieškos langą",
    "clearQuery": "Išvalyti paieškos užklausą",
    "closeSidebar": "Uždaryti meniu",
    "entireCollection": "Ieškoti {query} visoje kolekcijoje",
    "europeanaHome": "„Europeana“ pagrindinis puslapis",
    "inCollection": "Ieškoti {query} {collection}",
    "navigation": {
      "about": "Apie mus",
      "collections": "Kolekcijos",
      "europeanaClassroom": "Mokytojams",
      "help": "Pagalba",
      "home": "Namai",
      "pro": "Profesionalams",
      "stories": "Istorijos"
    },
    "quickSearch": "Greita paieška",
    "searchFor": "Ieškoti {query}",
    "searchForEverything": "Ieškoti visko",
    "searchForEverythingInCollection": "Ieškoti visko {collection}",
    "searchForEverythingInEntireCollection": "Ieškoti visko visoje kolekcijoje",
    "searchForm": "Paieškos forma",
    "showSidebar": "Rodyti meniu",
    "sideNavigation": "Šoninė navigacija"
  },
  "homeLinkAlt": "„Europeana“ pagrindinis puslapis",
  "homePage": {
    "discoverEditorial": "Naujausios istorijos",
    "storiesCTA": "Žiūrėti visas istorijas",
    "subHeadline": "Ieškokite, išsaugokite ir bendrinkite meną, knygas, filmus ir muziką iš tūkstančiųkultūrosįstaigų",
    "themesCTA": "Žiūrėti visas temas",
    "themesTitle": "Naršykite pagal temą",
    "title": "Pažinkite Europos {digital} kultūros paveldą",
    "titleDigital": "Skaitmeninis"
  },
  "imageSlider": {
    "handle": "Slinkiklio rankena"
  },
  "items": {
    "itemCount": "1 prekė iš |{count} prekių",
    "itemOf": "{max} iš {count} prekių",
    "recent": "Naujausi elementai",
    "recommended": "Rekomenduojami daiktai",
    "youMightLike": "Prekės, kurios jums gali patikti"
  },
  "klaro": {
    "main": {
      "acceptAll": "Priimti visus",
      "acceptSelected": "Priimti pasirinktą",
      "consentModal": {
        "description": "Mes rimtai žiūrime į jūsų duomenų privatumą. Čia galite įvertinti ir pritaikyti paslaugas, kurias norėtume naudoti šioje svetainėje. Jūs esate atsakingas! Įjunkite arba išjunkite paslaugas, kaip jums atrodo tinkama.",
        "title": "Paslaugos, kuriomis norėtume naudotis."
      },
      "consentNotice": {
        "description": "Mes rūpinamės jūsų privatumu ir naudojame duomenis tik tam, kad pagerintume jūsų patirtį. Reklamai nenaudojame jokios asmeninės informacijos. Savo sutikimą galite pakeisti kas 15 dienų.",
        "learnMore": "Leisk man pasirinkti"
      },
      "decline": "Aš atsisakau",
      "ok": "Gerai",
      "purposes": {
        "essential": {
          "description": "Šios paslaugos yra būtinos tinkamam šios svetainės veikimui. Jie apima paieškos rezultatų rodinį ir kalbos nuostatas, išsaugo prisijungusį būseną ir saugo jūsų apsilankymą. Negalite jų išjungti, nes svetainė kitaip neveiktų tinkamai.",
          "title": "Esminės saugos ir tinkinimo paslaugos"
        },
        "usage": {
          "description": "Šios tarnybos renka informaciją, kad galėtume geriau suprasti, kaip svetainė naudojama ir kur yra skausmo taškai, suteikdami mums galimybę rinktis pagrįstai, kad pagerintume jūsų patirtį.",
          "title": "Paslaugos, skirtos svetainės naudojimui ir atsiliepimams fiksuoti"
        }
      },
      "service": {
        "disableAll": {
          "description": "Šiuo jungikliu galite įjungti arba išjungti visas pasirenkamąsias paslaugas.",
          "title": "Įgalinti arba išjungti visas paslaugas"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Padeda tobulinti mūsų svetainę, retkarčiais pritaikant eksperimentinius pakeitimus.",
        "title": "A/B testavimas"
      },
      "auth-strategy": {
        "description": "Prisimena autorizacijos strategiją, kurią reikia naudoti prisijungiant.",
        "title": "Auth strategija"
      },
      "debugSettings": {
        "description": "Padeda derinti API užklausas",
        "title": "Derinti perjungti"
      },
      "hotjar": {
        "description": "Suaktyvina apklausos valdiklį, suteikdamas galimybę atsakyti į mūsų lankytojų pasitenkinimo apklausas.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Prisimena jūsų pageidaujamą sąsajos kalbą, kad galėtumėte ją pasiekti ateityje.",
        "title": "Kalbos kodas"
      },
      "jira-servicedesk": {
        "description": "Suaktyvina atsiliepimų valdiklį, suteikiantį galimybę susisiekti su mumis.",
        "title": "Jiros aptarnavimo stalas"
      },
      "matomo": {
        "description": "Renka anoniminę statistiką apie tai, kaip lankytojai sąveikauja su svetaine.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Rodomas pranešimas, kai atsiranda naujų funkcijų.",
        "title": "Pranešimas apie naują funkciją"
      },
      "searchResultsView": {
        "description": "Prisimena, ar norite paieškos rezultatus matyti sąrašo ar tinklelio rodinyje.",
        "title": "Paieškos rezultatų rodinys (sąrašas / tinklelis)"
      }
    }
  },
  "layout": {
    "skipToMain": "Pereiti į puslapio turinį"
  },
  "learnMore": "Sužinokite apie šio aprašymo šaltinį",
  "loading": "Įkeliama",
  "loadingResults": "Įkeliami rezultatai",
  "messages": {
    "copyToClipboardSuccess": "Nukopijuota į mainų sritį",
    "externalContentError": "Nepavyko įkelti išorinio turinio",
    "notFound": "Nerasta",
    "paginationLimitExceeded": "Galima peržiūrėti tik pirmuosius {limit} paieškos rezultatus."
  },
  "modal": {
    "download": {
      "clickToCopy": "Spustelėkite priskyrimą, kad jį nukopijuotumėte",
      "modalIntro": "Jei šį elementą naudojate žiniatinklyje ar kitur, nepamirškite šalia jo rodyti šio priskyrimo:",
      "modalTitle": "Pasakykite ačiū"
    }
  },
  "multilingual": {
    "automated": "Automatinis vertimas",
    "enrichment": "Praturtinimas partnerių projektais",
    "other": "Kitos kalbos",
    "stopTranslating": "Nustokite versti šį elementą į {0}.",
    "translateLanguage": "Ar norėtumėte pamatyti šį elementą {0} ?",
    "translateQuotaError": "Vertimo paslauga laikinai nepasiekiama. Pabandykite dar kartą vėliau."
  },
  "newFeatureNotification": {
    "dismiss": "Uždaryti",
    "readMore": "Skaityti daugiau",
    "text": {
      "searchFilters": "Dabar galite ieškoti reikšmių atskiruose filtruose; patikrinkite!"
    }
  },
  "newWindow": "atsidaro naujame lange",
  "noMoreResults": "Daugiau nėra rezultatų pagal jūsų paieškos užklausą.",
  "noResults": "Rezultatų nėra",
  "of": "Iš",
  "organisation": {
    "city": "Miestas",
    "country": "Šalis",
    "englishName": "Angliškas pavadinimas",
    "nameAcronym": "Pavadinimo akronimas"
  },
  "pageHasLoaded": "įkelta",
  "pageNumber": "Puslapio numeris",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Vardas"
        },
        "title": "Organizacijos"
      },
      "persons": {
        "title": "Asmenys"
      },
      "places": {
        "title": "Vietos"
      },
      "table": {
        "items": "Elementus",
        "name": "Vardas"
      },
      "times": {
        "title": "Laikai"
      },
      "topics": {
        "title": "Temos"
      }
    }
  },
  "pagination": {
    "label": "Numeracija"
  },
  "readMore": "Skaityti daugiau",
  "recommendation": {
    "prompts": {
      "accept": "Nykščiu aukštyn, kad pridėtumėte į galeriją",
      "reject": "Nykščiu žemyn, jei nepatinka"
    }
  },
  "record": {
    "IIIFViewer": "IIIF žiūrovas",
    "actions": {
      "pin": "Prisekite elementą prie galimų objektų"
    },
    "allMetaData": "Visi metaduomenys",
    "copyEmbedLabel": "Įterpti kodą (spustelėkite, jei norite kopijuoti)",
    "exploreMore": "Sužinokite daugiau",
    "extendedInformation": "Išplėstinė informacija",
    "goodToKnow": "Naudinga žinoti",
    "hideAll": "Slėpti visą informaciją",
    "location": "Vieta",
    "locationOnMap": "Vieta žemėlapyje",
    "mediaPlayer": "Medijos leistuvas",
    "record": "Įrašas",
    "showAll": "Rodyti visą informaciją",
    "similarItems": "Panašūs elementai",
    "status": {
      "unpublished": "[Nepaskelbtas elementas]"
    },
    "transcription": "Transkripcija",
    "transcriptionDisclaimer": "Šį turinį patalpino visuomenės narys, o ne prekę pateikusi įstaiga."
  },
  "related": {
    "editorial": {
      "title": "Istorijos, kurios jums gali patikti"
    }
  },
  "relatedCollections": "Susiję rinkiniai",
  "removeFilter": "Pašalinkite filtrą {filterLabel}",
  "reset": "Atstatyti",
  "resourceWikimedia": "Šaltinis iš „Wikimedia Commons“",
  "results": "Rezultatai",
  "resultsFor": "Rezultatai pagal užklausą {0}",
  "resultsLimitWarning": "Papildomi rezultatai nerodomi, nes parodomi tik pirmieji 1000 tinkamiausių rezultatų. Jei neradote to, ko ieškote, apsvarstykite galimybę patikslinti paiešką.",
  "resultsWithin": "Rezultatai pagal {0} {1} už {2}",
  "search": {
    "boost": {
      "placeholder": "Įveskite lauko didinimo užklausą"
    },
    "title": "Paieška"
  },
  "searchHasLoaded": "{0} grąžinti rezultatai",
  "searchPlaceholder": "Paieška 50+ milijonų elementų",
  "searchResults": "Paieška",
  "searchResultsFor": "{0} - Ieškoti",
  "searchSuggestions": "Paieškos pasiūlymai",
  "searchTier": {
    "button": {
      "hide": "Paslėpti šiuos elementus",
      "show": "Rodyti šiuos elementus"
    },
    "text": {
      "hide": "Rodomi elementai, neatitinkantys mūsų paskelbimo kriterijų.",
      "show": "Daugiau elementų atitinka jūsų paiešką, bet neatitinka mūsų paskelbimo kriterijų."
    }
  },
  "searchViews": {
    "grid": "Tinklelio rodinys",
    "list": "Sąrašo rodinys",
    "mosaic": "Mozaikos vaizdas"
  },
  "set": {
    "actions": {
      "addTo": "Įtraukti į galeriją",
      "create": "Kurti galeriją",
      "createNew": "Kurti naują galeriją",
      "delete": "Naikinti galeriją",
      "edit": "Redaguoti galeriją",
      "update": "Atnaujinti galeriją"
    },
    "form": {
      "description": "Galerijos aprašymas",
      "private": "Palikti galeriją privačią",
      "required": "Privalomi laukai",
      "title": "Galerijos pavadinimas"
    },
    "labels": {
      "curatedBy": "Kuruoja",
      "private": "Privati galerija"
    },
    "notifications": {
      "deleted": "Jūsų galerija panaikinta.",
      "likeLimit": {
        "body": "Atsiprašome, tačiau šiuo metu negalite turėti daugiau nei 100 patikusių prekių. Greitai šį apribojimą panaikinsime!",
        "title": "100 patinka"
      },
      "updated": "Elementas buvo įtrauktas į galeriją."
    },
    "prompts": {
      "delete": "Ar tikrai norite naikinti šią galeriją? Jei ją panaikinsite, prarasite visas į ją įtrauktas prekes."
    }
  },
  "showLess": "Rodyti mažiau",
  "showMore": "Rodyti daugiau",
  "sideFilters": {
    "noOptions": "Nėra parinkčių, kurias būtų galima pasirinkti",
    "search": "Paieška"
  },
  "statuses": {
    "liked": "Patiko",
    "pinned": "Prisegtas"
  },
  "storiesPage": {
    "title": "Istorijos"
  },
  "website": "Interneto svetainė",
  "youMightAlsoLike": "Jums taip pat gali patikti"
};
